export const AboutUsDataEn = {
  title: {
    all: 'Andersen in Europe',
    us: 'Andersen Global in Europe, North America, and the Middle East',
    az: 'Andersen in Azerbaijan',
    mena: 'Andersen Global in Europe, North America, and the Middle East',
    kz: 'Andersen in Kazakhstan',
  },
  description: {
    all: 'As a well-established European software development company, Andersen has earned the trust of its many customers operating all over the EU. Our team will analyze and fully understand your needs to start delivering the best possible industry-focused IT solutions. Andersen`s history, customer referrals, and experienced employees are your guarantee of success.',
    us: 'Over the years, we have established ourselves as a trusted tech partner globally. Our managerial expertise encompasses international, regional, and domain-related knowledge, and our processes enable us to offer tailored services.',
    az: "Andersen has been successfully cooperating with leading Azerbaijan customers for years, providing them with top-notch and tailored-fit software solutions. To facilitate these collaborations and find new opportunities, Andersen opened an office in this country. This is a long-anticipated and big step forward for Andersen's team, as we are determined to strengthen our position in this growing and promising market.",
    mena: 'Over the years, we have established ourselves as a trusted tech partner globally. Our managerial expertise encompasses international, regional, and domain-related knowledge, and our processes enable us to offer tailored services.',
    kz: "Andersen operates growing offices in Astana and Almaty, allowing us to benefit from the local economic prospects, advantageous location, and advanced local talent. From these locations, we execute complex projects for multiple existing customers  and continually establish new partnerships, contributing to the country's technological and economic growth.",
  },
  mapOptions: {
    all: {
      initialCoordinates: [50.0, 11.0],
      initialZoom: 5,
    },
    us: {
      initialCoordinates: [42.31, -31.75],
      initialZoom: 2,
    },
    az: {
      initialCoordinates: [40.38, 49.86],
      initialZoom: 4,
    },
    mena: {
      initialCoordinates: [42.31, -31.75],
      initialZoom: 2,
    },
    kz: {
      initialCoordinates: [47.34, 71.4],
      initialZoom: 5,
    },
  },
};

export const AboutUsDataDe = {
  title: {
    all: 'Andersen in Europa',
  },
  description: {
    all: 'Andersen ist ein renommiertes Softwareentwicklung-Unternehmen, dem Kunden in ganz Europa vertrauen. Unser Team analysiert Ihre Anforderungen bis ins Detail, um Ihnen passgenaue, branchenspezifische IT-Lösungen zu liefern. Dank unserer langjährigen Erfahrung und zahlreicher positiver Kundenempfehlungen sind wir Ihr verlässlicher Partner für nachhaltigen Erfolg.',
  },
  mapOptions: {
    all: {
      initialCoordinates: [50.0, 11.0],
      initialZoom: 5,
    },
  },
};

export const AboutUsDataAz = {
  title: {
    az: 'Andersen Azərbaycanda',
  },
  description: {
    az: 'Andersen Azərbaycanda aparıcı şirkətlər olan müştəriləri ilə illərdir ki, uğurla əməkdaşlıq edir, onlara xüsusi sifarişlə hazırlanmış ən müasir, mükəmməl proqram həlləri təqdim edir. Bu əməkdaşlıqları asanlaşdırmaq və yeni imkanlar əldə etmək üçün Andersen şirkəti Bakıda öz ofisini açdı. Bu, Andersen komandası üçün çoxdan gözlədiyimiz böyük bir addımdır, çünki biz bu inkişaf edən bazarda çox sayda müasir İT təşəbbüslərimizlə mövqeyimizi möhkəmləndirməyə qərarlıyıq.',
  },
  mapOptions: {
    az: {
      initialCoordinates: [40.38, 49.86],
      initialZoom: 4,
    },
  },
};

export const AboutUsDataAe = {
  title: {
    ae: 'أندرسن جلوبال في أوروبا وأمريكا الشمالية والشرق الأوسط',
  },
  description: {
    ae: 'على مدار السنين، أثبتنا أنفسنا كشريك تقني موثوق به على مستوى العالم. فبفضل خبرتنا الإدارية ومعرفتنا القوية على الصعيد الدولي والإقليمي والمتعلقة بالمجال تمكننا من تقديم خدمات متميزة ومخصصة لعملائنا.',
  },
  mapOptions: {
    ae: {
      initialCoordinates: [42.31, -31.75],
      initialZoom: 2,
    },
  },
};
